import { DEFAULT_DESCRIPTION } from './const'
import { ButtonContainer, DescriptionText, StyledDiv } from './style'

export const HeroBanner = ({ children, ...style }) => (
  <StyledDiv {...style}>
    <DescriptionText>{DEFAULT_DESCRIPTION}</DescriptionText>
    <ButtonContainer $margin="20px 0">{children}</ButtonContainer>
  </StyledDiv>
)
